module.exports = __webpack_public_path__ + "static/media/poster3.82cd30de.png";